import React from 'react';
const designs = [{
  icon: '🖼️',
  title: 'Cuadros decorativos'
}, {
  icon: '🐶',
  title: 'Retratos de mascotas'
}, {
  icon: '🌸',
  title: 'Diseños florales'
}, {
  icon: '🏡',
  title: 'Decoración boho'
}, {
  icon: '🧸',
  title: 'Decoración infantil'
}, {
  icon: '🪞',
  title: 'Espejos decorados'
}];
export function DesignShowcase() {
  return <section className="py-8 md:py-12 px-4 max-w-5xl mx-auto" data-id="element-51">
      <div className="text-center mb-6" data-id="element-52">
        <h2 className="font-heading text-2xl md:text-3xl text-brand-dark font-bold mb-2" data-id="element-53">
          ✨ Diseños reales que vas a poder crear
        </h2>
        <p className="text-brand-text text-sm md:text-base" data-id="element-54">
          Inspiración Creativa — Lo que vas a poder crear
        </p>
        <p className="text-brand-text mt-1 text-sm md:text-base" data-id="element-55">
          Diseños modernos, fáciles de realizar y altamente valorados.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-id="element-56">
        {designs.map((item, i) => <div key={i} className="bg-white rounded-2xl p-4 shadow-sm border border-brand-cream hover:shadow-md transition-shadow flex flex-col items-center text-center gap-2" data-id="element-57">
            <span className="text-3xl" data-id="element-58">{item.icon}</span>
            <h3 className="font-semibold text-brand-dark text-sm md:text-base" data-id="element-59">
              {item.title}
            </h3>
          </div>)}
      </div>

      <div className="mt-6 max-w-2xl mx-auto bg-white p-5 rounded-2xl shadow-sm border border-brand-cream" data-id="element-60">
        <ul className="space-y-2" data-id="element-61">
          <li className="flex items-center gap-3 text-brand-dark" data-id="element-62">
            <span className="text-xl" data-id="element-63">🌸</span> Cuadros decorativos artesanales
          </li>
          <li className="flex items-center gap-3 text-brand-dark" data-id="element-64">
            <span className="text-xl" data-id="element-65">🐶</span> Retratos personalizados de
            mascotas
          </li>
          <li className="flex items-center gap-3 text-brand-dark" data-id="element-66">
            <span className="text-xl" data-id="element-67">🪞</span> Espejos decorados
          </li>
          <li className="flex items-center gap-3 text-brand-dark" data-id="element-68">
            <span className="text-xl" data-id="element-69">🏡</span> Decoración estilo boho
          </li>
          <li className="flex items-center gap-3 text-brand-dark" data-id="element-70">
            <span className="text-xl" data-id="element-71">🧸</span> Decoración para habitaciones
            infantiles
          </li>
        </ul>
      </div>
    </section>;
}